// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentContainer_container__2VqYy","title":"ContentContainer_title__2eqad","mobile":"ContentContainer_mobile__3nnNW"};